/**
 * Tab body: "Sync runs" — short audit log of recent reconciliation
 * runs (top 15). Each row shows when the run started, which campaign
 * + window, how many rows came back, and how many matched a known pub.
 */
export default function RunsTab({ runs, loading }) {
  return (
    <div className="border border-slate-200 rounded-md overflow-hidden">
      <table className="w-full text-sm">
        <thead className="bg-slate-50">
          <tr className="border-b border-slate-200">
            <th className="text-left px-4 py-2.5 text-xs uppercase tracking-wider text-slate-500 font-bold">Started</th>
            <th className="text-left px-4 py-2.5 text-xs uppercase tracking-wider text-slate-500 font-bold">Campaign</th>
            <th className="text-right px-4 py-2.5 text-xs uppercase tracking-wider text-slate-500 font-bold">Window</th>
            <th className="text-right px-4 py-2.5 text-xs uppercase tracking-wider text-slate-500 font-bold">Total</th>
            <th className="text-right px-4 py-2.5 text-xs uppercase tracking-wider text-slate-500 font-bold">Matched</th>
            <th className="text-center px-4 py-2.5 text-xs uppercase tracking-wider text-slate-500 font-bold">Status</th>
          </tr>
        </thead>
        <tbody>
          {runs.map((r) => (
            <tr key={r.id} className="border-b border-slate-100 hover:bg-slate-50">
              <td className="px-4 py-3 text-xs text-slate-600">{r.started_at ? new Date(r.started_at).toLocaleString() : "—"}</td>
              <td className="px-4 py-3 text-xs text-slate-700">{r.campaign_label}</td>
              <td className="px-4 py-3 text-right text-xs font-mono text-slate-500">{r.start_date} → {r.end_date}</td>
              <td className="px-4 py-3 text-right font-mono text-xs">{r.total_rows ?? 0}</td>
              <td className="px-4 py-3 text-right font-mono text-xs">{r.matched_to_pub ?? 0}</td>
              <td className="px-4 py-3 text-center">
                <span className={`inline-flex items-center px-2 py-0.5 rounded text-xs font-medium ${
                  r.status === "completed" ? "bg-emerald-50 text-emerald-700" :
                  r.status === "failed" ? "bg-rose-50 text-rose-700" : "bg-amber-50 text-amber-700"
                }`}>{r.status || "running"}</span>
              </td>
            </tr>
          ))}
          {runs.length === 0 && !loading && (
            <tr><td colSpan={6} className="px-4 py-6 text-center text-sm text-slate-400">No sync runs yet.</td></tr>
          )}
        </tbody>
      </table>
    </div>
  );
}
